export const FF_CHECKOUT_INITIALIZE_V2 = 'FF_CHECKOUT_INITIALIZE_V2';
export const FF_ADD_TO_CART_ON_APP_CART = 'FF_ADD_TO_CART_ON_APP_CART';
